import { DialogRoot, DialogTrigger } from '@ibsys/kit';
import { RefreshCwIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui';
import { RecordingFetchRetryDialog } from './RecordingFetchRetryDialog';

type Props = {
  /** Повторный запрос записи; зовётся только после подтверждения в окне */
  onConfirm: () => void;
};

/**
 * Значок повторного запроса записи диалога у интеграции-источника: открывает окно подтверждения,
 * и запрос уходит только по согласию пользователя.
 *
 * Стоит в строке текста сообщения и не выше неё (отрицательный отступ по вертикали), поэтому
 * сообщение со значком той же высоты, что и без него, в любом месте показа.
 */
export const RecordingFetchRetryButton: FC<Props> = ({ onConfirm }) => {
  const { t } = useTranslation('dialogs');

  return (
    <DialogRoot>
      <IconButton
        size="icon"
        className="ml-1.5 -my-1 size-6 align-middle"
        label={t('audioFetchRetry.label')}
        icon={<RefreshCwIcon className="size-3.5" />}
        trigger={DialogTrigger}
      />
      <RecordingFetchRetryDialog onConfirm={onConfirm} />
    </DialogRoot>
  );
};
